import cloneDeep from 'helpers/cloneDeep';

const hashCssMemory = {};

export default function combineStyles(original, combine, customStyles) {

  if (!combine && !original && !customStyles) return {};
  if (!original && combine && !customStyles) return combine;
  if (!combine && original && !customStyles) return original;

  const constructHashKey = JSON.stringify(original)+JSON.stringify(combine)+JSON.stringify(customStyles);

  if (hashCssMemory[constructHashKey]) return hashCssMemory[constructHashKey];

  const custom = customStyles && typeof customStyles === 'object' ? customStyles : '';

  const combinedStyles = cloneDeep(original);


  function fnCombine(thisCombine) {

    if (thisCombine) {
      Object.entries(thisCombine).forEach((combineEntry) => {

        const [combineKey, combineValue] = combineEntry;
  
        if (!combinedStyles[combineKey]) combinedStyles[combineKey] = {};
  
        Object.entries(combineValue).forEach((cssEntry) => {
  
          const [cssKey, cssValue] = cssEntry;
  
          if (!combinedStyles[combineKey][cssKey]) combinedStyles[combineKey][cssKey] = {};
          combinedStyles[combineKey][cssKey] = {...combinedStyles[combineKey][cssKey], ...cssValue};
        });
  
      });
    }
  }

  if (Array.isArray(combine)) {
    for (let i = 0; i < combine.length; i++) {
      fnCombine(combine[i]);
    }
  } else {
    fnCombine(combine);

    if (custom && combinedStyles) {

      Object.entries(combinedStyles).forEach((combineEntry) => {

        const [combineKey, combineValue] = combineEntry;
  
        if (!combinedStyles[combineKey]) combinedStyles[combineKey] = {};
  
        Object.entries(combineValue).forEach((cssEntry) => {
  
          const [cssKey, cssValue] = cssEntry;

          Object.entries(cssValue).forEach((cssEntryValues) => {
  
            const [cssEntryValuesKey, cssEntryValuesValue] = cssEntryValues;

            if (cssEntryValuesValue) {
              const matcherKeyToString = cssEntryValuesValue.toString();
              if (matcherKeyToString.match(/\{(.*?)\}/)) {

                const thisMatcher = cssEntryValuesValue.replace('{', '').replace('}', '');
                if (customStyles[thisMatcher]) {
                  combinedStyles[combineKey][cssKey][cssEntryValuesKey] = customStyles[thisMatcher];
                }

              }
  
            }
          });
        });
  
      });
    }
  }


  hashCssMemory[constructHashKey] = combinedStyles;
  return combinedStyles;
}